import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';
import { WEEKDAYS_SHORT } from '../../i18n/timeLocaleData';

const styles = {
  wrapper: {
    padding: 15
  },
};

@injectIntl
class CsatByDayOfWeekBarChart extends Component {

  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const csatByDayOfWeek = answersReport ? answersReport.csatByDayOfWeek : [];

    const categories = csatByDayOfWeek.map(item => {
      return WEEKDAYS_SHORT[intl.locale][item.dayOfWeek % 7];
    });
    const data = csatByDayOfWeek.map(item => item.csat * 100);

    const chartConfig = {
      chart: {
        type: 'column',
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
        marginLeft: 20,
        marginRight: 20,
      },
      title: {
        text: intl.formatMessage({ id: 'csat' }),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          }, {
            count: csatByDayOfWeek[index].count,
          });
        },
      },
      xAxis: {
        categories,
        title: {
          text: intl.formatMessage({ id: 'dayOfWeek' }),
        },
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}%',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  CsatByDayOfWeekBarChart,
  graphql`
    fragment CsatByDayOfWeekBarChart_answersReport on AnswersReport {
      csatByDayOfWeek {
        dayOfWeek
        csat
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CsatByDayOfWeekBarChart/CsatByDayOfWeekBarChart.js